var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFullscreenExit = function SvgFullscreenExit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.708 20.5v-3.212H3.496v-1.5h4.712V20.5zm9.086 0v-4.711h4.712v1.5h-3.212V20.5zM3.496 8.212v-1.5h3.212V3.5h1.5v4.711zm12.298 0V3.5h1.5v3.212h3.212v1.5z"
  })));
};
export default SvgFullscreenExit;